import { useEffect, useRef } from 'react';
import QR from 'qrcode';

export interface QRCodeProps {
  value: string;
  size?: number;
  margin?: number;
}

export function QRCode({ value, size = 220, margin = 1 }: QRCodeProps) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    QR.toCanvas(ref.current, value, {
      width: size,
      margin,
      color: { dark: '#0f0f0f', light: '#ffffff' },
      errorCorrectionLevel: 'M',
    }).catch(() => undefined);
  }, [value, size, margin]);

  return <canvas ref={ref} width={size} height={size} className="rounded-lg bg-white" />;
}

export function downloadQR(canvas: HTMLCanvasElement | null, filename: string) {
  if (!canvas) return;
  const url = canvas.toDataURL('image/png');
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
}
